import Format from '../utility/Format';
import LaneClosureRequest from './LaneClosureRequest';

export default class AuditLogClosure {
    constructor(data) {
        data.forEach(item => {
            this.constructFields(item);
        });
    }

    constructFields(data) {
    	if (data.changesDetails == null) {
    		return;
    	}
        let dataJson = JSON.parse(data.changesDetails)["Lanes"];

        let lanes = dataJson.filter(item => item.LaneType == "Lane");
        let sidewalks = dataJson.filter(item => item.LaneType == "Sidewalk");
        let bicycle = dataJson.filter(item => item.LaneType == "Bicycle");

        this.lanes = {}, this.sidewalks = {}, this.bicycle = {}

        lanes.forEach(item => {
            if (!this.lanes[item.LaneId]) {
                this.lanes[item.LaneId] = {
                    text: Format.searchByGroupedId(item.LaneId, LaneClosureRequest.getLaneAffectedOptions).name,
                    img: Format.searchByGroupedId(item.LaneId, LaneClosureRequest.getLaneAffectedOptions).img,
                    items: []
                };
            }
            this.lanes[item.LaneId].items.push(item);
        });
        sidewalks.forEach(item => {
            if (!this.sidewalks[item.LaneId]) {
                this.sidewalks[item.LaneId] = {
                    text: Format.searchById(item.LaneId, LaneClosureRequest.getSidewalkOptions).name,
                    img: Format.searchById(item.LaneId, LaneClosureRequest.getSidewalkOptions).img,
                    items: []
                };
            }
            this.sidewalks[item.LaneId].items.push(item);
        });
        bicycle.forEach(item => {
            if (!this.bicycle[item.LaneId]) {
                this.bicycle[item.LaneId] = {
                    text: Format.searchById(item.LaneId, LaneClosureRequest.getBicycleLaneOptions).name,
                    img: Format.searchById(item.LaneId, LaneClosureRequest.getBicycleLaneOptions).img,
                    items: []
                };
            }
            this.bicycle[item.LaneId].items.push(item);
        });
    }

    getContent() {
        return Object.values(this);
    }
}
